// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2h-pN","alert":"SettungsInbox_alert__1PUVj"};